import { BusStopHeader } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/BusStopHeader";
import { BusStopTableBody } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/BusStopTableBody";
import { TableXS } from "features/CenterContent/VehicleDetails/TrainDetails/TrainRoute/TrainRoute";
import { TableBody, TableHeader } from "shared/components/Spor";
import {
  AlternativeTransportVehicle,
  StopReference,
} from "shared/types/alternativeTransport";
import { useTheme } from "styled-components";

interface IncidentsAndStopsPanelsProps {
  vehicle: AlternativeTransportVehicle;
  distributionStopReferences: Array<StopReference>;
}

export const IncidentsAndStopsPanels = ({
  vehicle,
  distributionStopReferences,
}: IncidentsAndStopsPanelsProps) => {
  const theme = useTheme();

  return (
    <TableXS minWidth="0px">
      <TableHeader backgroundColor={theme.colorBackgroundTertiary}>
        <BusStopHeader />
      </TableHeader>
      <TableBody>
        <BusStopTableBody
          id={vehicle.id}
          travelDate={vehicle.scheduledDepartureTimeOrigin}
          itinerary={vehicle.itinerary}
          vehicleStatus={vehicle.vehicleStatus}
          distributionStopReferences={distributionStopReferences}
        />
      </TableBody>
    </TableXS>
  );
};
